import { createEffect, createEvent, createStore, sample } from 'effector';
import { endPoints } from 'shared/config/endPoints';
import { replace } from 'shared/lib/redirect';
import { authApi } from '../api';
import { TGetTokenFx } from '../types';
import { API } from 'shared/api/executor';
import { LOCAL_STORAGE_JWT_TOKEN } from 'shared/config/constants';

const resetToken = createEvent();

const setToken = createEvent<string>();
const $token = createStore<string>(localStorage.getItem(LOCAL_STORAGE_JWT_TOKEN) ?? null);

const cacheTokenFx = createEffect<string, void>((value) => {
  localStorage.setItem(LOCAL_STORAGE_JWT_TOKEN, value);
});

sample({
  clock: setToken,
  target: [cacheTokenFx, $token],
});

sample({
  clock: $token,
  filter: (token) => !token,
  fn: () => ({ pathname: endPoints.LOGIN, search: '' }),
  target: replace,
});

const getToken = createEvent<string>();
// const getTokenFx = createEffect<TGetTokenFx>(authApi.fetchJwtToken);
const getTokenFx = createEffect<TGetTokenFx>(() =>
  API().post('/merchants', {
    name: `Merchant 12345`,
    merchant_id: '12345',
    merchant_user_id: '12345',
  }),
);

sample({
  clock: getToken,
  target: getTokenFx,
});

sample({
  clock: getTokenFx.doneData,
  fn: (res) => res.data?.token,
  target: setToken,
});

sample({
  clock: resetToken,
  fn: () => null,
  target: $token,
});

export const token = {
  stores: {
    $token,
  },
  events: {
    setToken,
    getToken,
    resetToken,
  },
};
